import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

/* eslint-disable no-unused-vars */
import PhoneInputWithCountrySelector from "react-phone-number-input";
import React, { useLayoutEffect, useMemo, useRef, useState, useEffect } from "react";
import classNames from "classnames";
import { getClassNameFactory } from "../../utilities/classNames";
import InlineErrorMessage from "../../elements/InlineErrorMessage";
import { CountrySelector } from "./components/CountrySelector";
import { usePhoneNumberInputValidation } from "./PhoneNumberInputHooks";
import { DISPLAY_CLASS_NAME, defaultErrors, defaultForceShowError } from "./PhoneNumberInputConstants";
export var PhoneNumberInputWithCountrySelector = function PhoneNumberInputWithCountrySelector(_ref) {
  var className = _ref.className,
      countryDictionary = _ref.countryDictionary,
      defaultCountry = _ref.defaultCountry,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? defaultErrors : _ref$errors,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      onBlur = _ref.onBlur,
      countrySelectorProps = _ref.countrySelectorProps,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disableValidatio = _ref.disableValidation,
      disableValidation = _ref$disableValidatio === void 0 ? false : _ref$disableValidatio,
      _ref$forceShowError = _ref.forceShowError,
      forceShowError = _ref$forceShowError === void 0 ? defaultForceShowError : _ref$forceShowError,
      _ref$isValidationOnMo = _ref.isValidationOnMountRequired,
      isValidationOnMountRequired = _ref$isValidationOnMo === void 0 ? false : _ref$isValidationOnMo,
      props = _objectWithoutProperties(_ref, ["className", "countryDictionary", "defaultCountry", "errors", "id", "label", "onChange", "value", "onBlur", "countrySelectorProps", "required", "disableValidation", "forceShowError", "isValidationOnMountRequired"]);

  // we need this ref and state here to define country selector dropdown max width
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      countryDropdownContentMaxWidth = _useState2[0],
      setCountryDropdownContentMaxWidth = _useState2[1];

  var wrapperRef = useRef();
  var getClassName = getClassNameFactory(DISPLAY_CLASS_NAME);

  var _usePhoneNumberInputV = usePhoneNumberInputValidation(errors, required),
      errorMessage = _usePhoneNumberInputV.errorMessage,
      validateOnBlur = _usePhoneNumberInputV.validateOnBlur,
      validateOnChange = _usePhoneNumberInputV.validateOnChange,
      validateOnMount = _usePhoneNumberInputV.validateOnMount,
      isError = _usePhoneNumberInputV.isError;

  useLayoutEffect(function () {
    var _wrapperRef$current, _wrapperRef$current2;

    setCountryDropdownContentMaxWidth(((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.clientWidth) === 0 ? "100%" : "".concat((_wrapperRef$current2 = wrapperRef.current) === null || _wrapperRef$current2 === void 0 ? void 0 : _wrapperRef$current2.clientWidth, "px"));
  });
  useEffect(function () {
    if (isValidationOnMountRequired) {
      validateOnMount(value);
    }
  }, [isValidationOnMountRequired]);

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (!disableValidation) {
      validateOnBlur(event);
    }
  };

  var handleChange = function handleChange(phoneNumber) {
    onChange(phoneNumber);

    if (!disableValidation) {
      validateOnChange();
    }
  };

  var _useMemo = useMemo(function () {
    var shouldShowError = !disableValidation && isError;
    return [forceShowError.outlineError || shouldShowError, forceShowError.inlineError || shouldShowError];
  }, [forceShowError, isError, disableValidation]),
      _useMemo2 = _slicedToArray(_useMemo, 2),
      showOutlineError = _useMemo2[0],
      showInlineError = _useMemo2[1];

  var renderCountrySelector = function renderCountrySelector(renderProps) {
    return /*#__PURE__*/React.createElement(CountrySelector, _extends({}, renderProps, {
      dropdownContentMaxWidth: countryDropdownContentMaxWidth
    }));
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: function ref(_ref2) {
      wrapperRef.current = _ref2;
    },
    className: classNames(getClassName({
      descendantName: "wrapper",
      modifiers: "withCountrySelector"
    }), className)
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: id
  }, label), /*#__PURE__*/React.createElement(PhoneInputWithCountrySelector, _extends({
    className: getClassName({
      modifiers: showOutlineError && "isInvalid"
    }),
    countrySelectComponent: renderCountrySelector,
    countrySelectProps: countrySelectorProps,
    defaultCountry: defaultCountry,
    id: id,
    labels: countryDictionary,
    onBlur: handleBlur,
    onChange: handleChange,
    value: value,
    international: true
  }, props)), showInlineError && /*#__PURE__*/React.createElement(InlineErrorMessage, {
    className: classNames(getClassName({
      descendantName: "error"
    })),
    errorMessage: errorMessage,
    id: "error-".concat(id)
  }));
};
PhoneNumberInputWithCountrySelector.displayName = "PhoneNumberInputWithCountrySelector";